import Grid from "@mui/material/Grid";

import { DashboardZeffyLoader } from "@/dashboard-design-system/ZeffyLoader/DashboardZeffyLoader";

export interface ContainerLoaderProps {
  fullPage?: boolean;
}

export const ContainerLoader = ({ fullPage }: ContainerLoaderProps) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      sx={
        fullPage
          ? {
              height: "100vh",
              ["@supports (height: 100dvh)"]: { height: "100dvh" },
            }
          : { height: "100%" }
      }
    >
      <DashboardZeffyLoader size="large" />
    </Grid>
  );
};
